import { useEffect, useState } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className="relative w-full overflow-hidden">
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-background-50/95 backdrop-blur-sm'
            : 'bg-transparent'
        }`}
      >
        <div className="px-6 md:px-12 py-5 flex items-center justify-between">
          <h1 className="font-heading text-base md:text-lg font-semibold text-foreground-950 tracking-tight">
            JEANNSOFTWARE INC.
          </h1>
        </div>
      </nav>

      <section className="w-full pt-28 pb-16 md:pt-36 md:pb-24 px-6 md:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-start gap-10 md:gap-16">
            <div className="flex-1">
              <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-extrabold text-foreground-950 leading-[1.08] tracking-tight">
                Engineering the
                <br />
                future of iOS
              </h2>
            </div>
            <div className="flex-1 lg:pt-3">
              <p className="font-body text-base md:text-lg text-foreground-600 leading-relaxed max-w-lg">
                A professional engineering team dedicated to designing and developing modern
                digital software solutions for the iOS platform and related technologies. We
                build scalable, maintainable, and high-performance systems with a strong focus
                on usability, stability, and long-term technical quality.
              </p>
              <div className="mt-6 flex items-center gap-2 text-foreground-400">
                <span className="font-body text-sm tracking-widest uppercase">Discover</span>
                <span className="text-lg leading-none">&rarr;</span>
              </div>
            </div>
          </div>

          <div className="mt-14 md:mt-20 w-full">
            <div className="w-full h-[280px] md:h-[400px] rounded-3xl overflow-hidden bg-background-100 relative">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20geometric%20pattern%20with%20organic%20curves%20and%20precise%20lines%2C%20warm%20minimal%20color%20palette%20of%20beige%20charcoal%20and%20cream%20tones%2C%20sophisticated%20modern%20design%2C%20seamless%20subtle%20texture%2C%20elegant%20architectural%20composition%2C%20soft%20diffused%20atmosphere%2C%20delicate%20overlapping%20shapes%2C%20tone%20on%20tone%20treatment%2C%20no%20text%20no%20people&width=1600&height=400&seq=hero-abstract-pattern&orientation=landscape"
                alt="Abstract geometric pattern representing modern engineering design"
                title="Engineering design philosophy abstract visualization"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>
    </header>
  );
}